var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticStyle:{"padding":"10px 0","font-size":"13px"},attrs:{"label":_vm.title,"value":_vm.value,"outlined":!_vm.isIE,"dense":"","hide-details":"","readonly":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }